import { AbstractControl, ValidationErrors } from '@angular/forms';
import { VALID_US_AREA_CODES } from './us-area-codes'; // Adjust the path accordingly

/**
 * Validates US phone numbers by:
 * - stripping non-digits,
 * - removing a leading '1' (if present),
 * - ensuring exactly 10 digits remain,
 * - and verifying the area code is in the U.S. list.
 */
export function usPhoneValidator(control: AbstractControl): ValidationErrors | null {
  let value: string = (control.value || '').toString();
  let digits = value.replace(/\D/g, ''); // normalize

  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.substring(1);
  }

  if (digits.length !== 10) {
    return { invalidUSPhone: true };
  }

  const areaCode = digits.substring(0, 3);

  if (!VALID_US_AREA_CODES.has(areaCode)) {
    return { invalidUSPhone: true };
  }

  return null;
}
